function product() {
    var productsData = JSON.parse(sessionStorage.getItem('HoffmannProducts'));
    if (productsData) {
        $('.product').each(function() {
            var productCode = $(this).find('span[data-micro="sku"]').text().trim();
            var foundProduct = productsData.find(p => {
                if (p.VARIANTS) {
                    var variantCodes = p.VARIANTS.split(',');
                    return variantCodes.includes(productCode);
                }
                return false;
            });
            if(typeof foundProduct !== 'undefined'){
                if(typeof foundProduct.LOGO !== 'undefined'){
                    if (foundProduct && !$(this).find('.productBrandImage').length) {
                        $(this).find('.ratings-wrapper').prepend('<div class="productBrandImage"><img src="' + foundProduct.LOGO + '"></div>');
                    }
                }
                else{
                    if(!$(this).find('.productBrandImage').length) {
                        $(this).find('.ratings-wrapper').prepend('<div class="productBrandImage"></div>');
                    }
                }
                
            }
            else{
                if(!$(this).find('.productBrandImage').length) {
                    $(this).find('.ratings-wrapper').prepend('<div class="productBrandImage"></div>');
                }
            }
            
            if (foundProduct && !$(this).find('.productVariantcount').length) {
                var numberOfVariants = foundProduct.VARIANTS.split(',').length;
                function getVariantText(count) {
                    if (count === 1) {
                        return 'varianta';
                    } else if (count >= 2 && count <= 4) {
                        return 'varianty';
                    } else {
                        return 'variant';
                    }
                }
                var variantText = getVariantText(numberOfVariants);
                if(foundProduct.VARIANTS.split(',').length>0){
                    var variantcout = foundProduct.VARIANTS.split(',').length
                }
                else{
                    var variantcout = ''
                }
                if(variantcout>0){
                    $(this).find('.p-bottom>div').append('<div class="detailButton"><a href="'+$(this).find('a.image').attr('href')+'" class="productButtonDetail">K variantám</a></div>')
                }
                $(this).find('.ratings-wrapper').append('<div class="productVariantcount">'+variantcout+' '+variantText+'</div>');
                $(this).find('.p-bottom>div').append('<div class="productVariantcount">'+variantcout+' '+variantText+'</div>');
                
            }
            
        });
    }
    else{
        if(!$(this).find('.productBrandImage').length) {
            $(this).find('.ratings-wrapper').prepend('<div class="productBrandImage"></div>');
        }
    }
}

//https://feeds.mergado.com/zarety-plain-json-81812d293258ca71412e81fbf96f7b68.json

if (!sessionStorage.getItem('HoffmannProducts')) {
    $.ajax({
        url: '/user/documents/products.json?v=' + new Date().getMinutes(),
        type: 'GET',
        dataType: 'json',
        success: function(data) {
            var processedProducts = data.map(function(product) {
                if (product.VARIANTS && product.VARIANTS.VARIANT) {
                    var variantsArray = Array.isArray(product.VARIANTS.VARIANT) ? product.VARIANTS.VARIANT : [product.VARIANTS.VARIANT];
                    var codes = variantsArray.map(function(variant) {
                        return variant.CODE;
                    });
                    var codesString = codes.join(',');
                    product.VARIANTS = codesString;
                }        
                return product;
            });
          
            sessionStorage.setItem('HoffmannProducts', JSON.stringify(processedProducts));
            product();
        },
        error: function() {
            console.error('Chyba při načítání dat');
        }
    });
} else {
    console.log('Data již byla načtena a uložena ve storage.');
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        product()
        
    });
    document.addEventListener('ShoptetPageSortingChanged', function() {
        product();
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        product();
    });
    
    $(document).ready(function(){
        product();
    })
}